import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import cloud from '../../assets/icons/icons-cloud-product.svg'
import dish from '../../assets/icons/icons-dish-products.svg'
import discount from '../../assets/icons/icons-discounts-products.svg'
import cloudBlue from '../../assets/icons/icons-cloud-product-blue.svg'
import dishBlue from '../../assets/icons/icons-dish-products-blue.svg'
import discountBlue from '../../assets/icons/icons-discounts-products-blue.svg'
import '../../components/text/Text.css'
import Text from '../../components/text/Text'
import './Products.css'
import RedirectCard from '../../components/redirectCard/RedirectCard'
import { labels, clevertapEvents } from '../../labels'
import routes from '../../router/routes'
import { track } from '../../ClevertapWrapper'
import { format } from 'date-fns'
import { getLocal } from '../../Utils/Profile'

export default function Products() {
    const navigation = useNavigate()
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const [lat, setLat] = useState<number>(0)
    const [lng, setLng] = useState<number>(0)
    const clevertapData = {
        geoLocationLat: lat,
        geoLocationLong: lng,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        // ID: commerceId
    }
    const pageLoadData = {
        pageName: 'Cargar productos',
        pageURL: routes.products,
        geoLocationLat: lat,
        geoLocationLong: lng,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        codLocal: getLocal(),
    }
    const productEventParms = {
        pageName: 'Products',
        pageURL: routes.products,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    const getLocation = () => {
        navigator.geolocation.getCurrentPosition((position) => {
            setLat(position.coords.latitude)
            setLng(position.coords.longitude)
        })
    }

    const navigateToLiquidate = () => {
        track(clevertapEvents.productsLandingLiquidate, clevertapData)
        navigation(`/${routes.products}/${routes.liquidate}`)
        track(
            clevertapEvents.amiposweb_impulsatusventas_marketplace_cargarproductos_liquidar,
            productEventParms
        )
    }
    const navigateToIndividual = () => {
        track(clevertapEvents.productsLandingIndividual, clevertapData)
        navigation(`/${routes.products}/${routes.individualUpload}`)
        track(
            clevertapEvents.amiposweb_impulsatusventas_marketplace_cargarproductos_individual,
            productEventParms
        )
    }
    const navigateToMassive = () => {
        track(clevertapEvents.productsLandingMassive, clevertapData)
        navigation(`/${routes.products}/${routes.massiveUpload}`)
        track(
            clevertapEvents.amiposweb_impulsatusventas_marketplace_cargarproductos_masiva,
            productEventParms
        )
    }
    useEffect(() => {
        getLocation()
    }, [lat, lng])
    useEffect(() => {
        track(clevertapEvents.pageLoadnl, pageLoadData)
    }, [])
    return (
        <div className="container-products">
            <div>
                <Text
                    label={labels.productsTitle}
                    fontSize={27}
                    fontWeight={400}
                    color="#184287"
                    marginTop={40}
                    marginLeft={20}
                    marginBottom={20}
                />

                <div className="twolandingContainer-products">
                    <div className="landingContainer-products">
                        <RedirectCard
                            iconName={cloud}
                            iconActiveName={cloudBlue}
                            title={labels.productsMassiveCardTitle}
                            subtitle={labels.productsMassiveCardSubtitle}
                            handleOnPress={navigateToMassive}
                        />
                    </div>
                    <div className="landingContainer-products">
                        <RedirectCard
                            iconName={dish}
                            iconActiveName={dishBlue}
                            title={labels.productsIndividualUploadTitle}
                            subtitle={labels.productsIndividualUploadSubtitle}
                            handleOnPress={navigateToIndividual}
                        />
                    </div>

                    <div className="landingContainer-products">
                        <RedirectCard
                            iconName={discount}
                            iconActiveName={discountBlue}
                            title={labels.productsDiscountTitle}
                            subtitle={labels.productsDiscountSubtitle}
                            handleOnPress={navigateToLiquidate}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
